import React, { Component } from "react";

class Loader extends Component {
  render() {
    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          opacity: "0.7",
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0, 0.1)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className="loader"></div>
      </div>
    );
  }
}

export default Loader;
